import styled from "styled-components";
import { useIntl } from "react-intl";
import { color, fontSize, spacing } from "../../../../theme";
import { Timeline } from "../../Timeline";
import type { TransferCell } from "../cell/TransferCell";
import { transitSwitchMessages } from "./TroniconTimelineTransfer.messages";

type Props = {
  cell: TransferCell;
};

export function TroniconTimelineTransfer({ cell }: Props) {
  const intl = useIntl();

  return (
    <div className="flex items-center px-2">
      <Timeline type="transfer" transitMode="walk" />
      <LeftAligned>
        <span>{intl.formatMessage(transitSwitchMessages[cell.label])}</span>
      </LeftAligned>
    </div>
  );
}

const LeftAligned = styled.span`
  height: 100%;
  margin-right: auto;
  padding-left: ${spacing.xl};
  line-height: 24px;
  font-size: ${fontSize.h6};
  color: ${color.n90};

  display: flex;
  align-items: center;
  gap: ${spacing.xl};
  padding-top: ${spacing.lg};
  padding-bottom: ${spacing.lg};
`;
